module.exports = __webpack_public_path__ + "static/img/goodsliststyle1.3c977ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diy/goodsliststyle1.png
// module id = 46V5
// module chunks = 174